import { render, staticRenderFns } from "./LimparIdPedidoManutencao.vue?vue&type=template&id=542f3152&scoped=true&"
import script from "./LimparIdPedidoManutencao.vue?vue&type=script&lang=js&"
export * from "./LimparIdPedidoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./LimparIdPedidoManutencao.vue?vue&type=style&index=0&id=542f3152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f3152",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
